/* eslint-disable react/no-array-index-key */
import * as React from "react";
import {
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
  Avatar,
} from "react-md";
import { StatelessComponent } from "react";

interface IPredictionTableProps {
  expertResults: IExpertResult[];
}

const PredictionResultsTable: StatelessComponent<IPredictionTableProps> = (props) => (
  <DataTable plain>
    <TableHeader>
      <TableRow>
        <TableColumn/>
        <TableColumn grow>Эксперт</TableColumn>
        <TableColumn>Счет</TableColumn>
        <TableColumn>Разница</TableColumn>
        <TableColumn>Исход</TableColumn>
        <TableColumn>Сумма</TableColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
      {props.expertResults.map((expRes, i) => (
        <TableRow key={i}>
          <TableColumn>{i + 1}</TableColumn>
          <TableColumn>{expRes.nickname}</TableColumn>
          <TableColumn>{expRes.scores}</TableColumn>
          <TableColumn>{expRes.differences}</TableColumn>
          <TableColumn>{expRes.outcomes}</TableColumn>
          <TableColumn>
            <Avatar suffix="teal">{expRes.sum}</Avatar>
          </TableColumn>
        </TableRow>
      ))}
    </TableBody>
  </DataTable>
);

export default PredictionResultsTable;


// WEBPACK FOOTER //
// ./src/components/tables/PredictionResultsTable.tsx